import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["drawer", "trigger", "transfers"];

  declare readonly drawerTarget: HTMLDialogElement;
  declare readonly triggerTarget: HTMLButtonElement;
  declare readonly transfersTarget: HTMLElement;

  private desktop = window.matchMedia("(min-width: 64rem)");
  private readonly resize = () => {
    if (!this.drawerTarget.open) return;
    this.drawerTarget.close();
    this.open();
  };

  connect() {
    this.desktop.addEventListener("change", this.resize);
  }

  disconnect() {
    this.desktop.removeEventListener("change", this.resize);
    document.body.removeAttribute("data-budgeter-transaction-filters-modal");
  }

  toggle() {
    if (this.drawerTarget.open) this.close();
    else this.open();
  }

  private open() {
    if (this.desktop.matches) this.drawerTarget.show();
    else this.drawerTarget.showModal();
    this.element.setAttribute("data-filters-open", "");
    this.triggerTarget.setAttribute("aria-expanded", "true");
    document.body.toggleAttribute(
      "data-budgeter-transaction-filters-modal",
      !this.desktop.matches,
    );
  }

  close() {
    this.drawerTarget.close();
    this.closed();
  }

  closed() {
    // A breakpoint change closes and immediately reopens the same drawer.
    if (this.drawerTarget.open) return;
    this.element.removeAttribute("data-filters-open");
    this.triggerTarget.setAttribute("aria-expanded", "false");
    document.body.removeAttribute("data-budgeter-transaction-filters-modal");
    this.triggerTarget.focus({ preventScroll: true });
  }

  cancel(event: Event) {
    event.preventDefault();
    this.close();
  }

  escape(event: KeyboardEvent) {
    if (!this.desktop.matches || !this.drawerTarget.open) return;
    if (this.drawerTarget.querySelector("dialog[open]")) return;
    event.preventDefault();
    this.close();
  }

  backdrop(event: MouseEvent) {
    if (event.target !== this.drawerTarget || this.desktop.matches) return;
    const rect = this.drawerTarget.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom) this.close();
  }

  beforeCache() {
    this.close();
  }

  categoryChanged(event: Event) {
    const form = event.target as HTMLFormElement;
    const category = form.elements.namedItem("[]category") as HTMLSelectElement;
    this.transfersTarget.hidden = category.value !== "00000000-0000-0000-0000-000000000000";
  }
}
